import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';
import './styles/consid-register.scss';
import './styles/pages/index.scss';
import 'bootstrap/dist/js/bootstrap';
// IMPORT POPPER IF NEEDED
// IMPORT JQUERY IF NEEDED
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n/config';

const rootElement = document.getElementById('root');

ReactDOM.render(<App />, rootElement);
